import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

// import { liveAndUpcoming as liveAndUpcomingData } from '../mockData';

export default () => {

  const fetchBrowse = async () => {
    const { data } = await axios.get('/api/learner/videos/browse');
    return data;
  };

  const fetchLiveAndUpcoming = async () => {
    const { data } = await axios.get('/api/learner/live_videos');
    return data;
  };

  const { data: browse, isLoading } = useQuery(['browse'], fetchBrowse);

  const { data: liveAndUpcoming } = useQuery(['liveAndUpcoming'], fetchLiveAndUpcoming);

  return {
    browse,
    liveAndUpcoming,
    isLoading,
  };
};
